import React from 'react';

import { Badge } from 'shadcn/components/ui/Badge';
import { Button } from 'shadcn/components/ui/Button';

export function FilterChip({ className = '', deletable = false, label, onClick, onDelete, title }) {
    return (
        <Badge
            variant="secondary"
            className={`flex items-center gap-2 cursor-pointer rounded-md bg-gray-200 px-3 py-1 ${className}`}
            onClick={onClick}
            title={title}
        >
            <span className="whitespace-normal break-words">{label}</span>
            {deletable && (
                <Button
                    size="icon"
                    variant="ghost"
                    className="h-4 w-4 p-0"
                    aria-label={`Remove ${label} filter`}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onDelete) onDelete();
                    }}
                >
                    ✕
                </Button>
            )}
        </Badge>
    );
}
